/* eslint-disable no-underscore-dangle */

/*
  The "Add to Registry" button on the PDP is injected via the Gift Reggie app embed,
  preventing direct modifications to its JavaScript logic for triggering a confirmation notification.

  However, since the button's text updates dynamically—
  "Add to Registry" → "..." (processing) → "Added to Registry" (success)—
  we can hook into these changes using a MutationObserver.

  This allows us to detect when the registry has been added and display a confirmation notification.
*/

WYATT.registerComponent(
  "registry-added-confirmation",
  class RegistryAddedConfirmation extends HTMLElement {
    constructor() {
      super();

      this.giftReggieSettings = this.getGiftReggieSettings();

      if (!this.giftReggieSettings) {
        console.warn("Unable to fetch Gift Reggie settings");
        return;
      }

      this.watchRegistryButtonText();
    }

    onPending() {
      // no-op
    }

    onSuccess() {
      WYATT.createMessage(
        "success",
        `${WYATT.t.addToRegistry.addSuccess}. <a href="/apps/giftregistry/registry/${WYATT.shopify.registry.id}">${WYATT.t.addToRegistry.goToRegistry}</a>.`
      );
    }

    getGiftReggieSettings() {
      try {
        return JSON.parse(
          document.getElementById("gift_reggie_data").textContent
        );
      } catch {
        return;
      }
    }

    watchRegistryButtonText() {
      const button = this.querySelector(".giftreggie-pdp-registry-cta");

      if (!button) {
        return;
      }

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type !== "childList") {
            return;
          }

          if (
            button.textContent === this.giftReggieSettings.i18n.registry.pending
          ) {
            this.onPending();
            return;
          }

          if (
            button.textContent ===
            this.giftReggieSettings.i18n.registry.successAdd
          ) {
            this.onSuccess();
            return;
          }
        });
      });

      observer.observe(button, { childList: true });
    }
  }
);
